import axios from "axios";

export const GET_LIST_USERS = "GET_LIST_USERS";
export const GET_PENDING_USERS = "GET_PENDING_USERS";
export const USER_REGISTER = "USER_REGISTER";
export const USER_EDIT = "USER_EDIT";
export const USER_DELETE = "USER_DELETE";
export const ADD_PROVIDER_IN_USER = "ADD_PROVIDER_IN_USER";
export const DELETE_PROVIDER_IN_USER = "DELETE_PROVIDER_IN_USER";
export const GET_USER_ROLES = "GET_USER_ROLES";
export const CREATE_PENDING_USER = "CREATE_PENDING_USER";
export const REGISTER_PENDING_USER = "REGISTER_PENDING_USER";
export const GET_PROVIDER_USERS = "GET_PROVIDER_USERS";
export const USER_REJECT = "USER_REJECT";
export const TOGGLE_MFA = "TOGGLE_MFA";
export const UNLOCK_USER = "UNLOCK_USER";
export const UPDATE_USER_MFA_STATUS = "UPDATE_USER_MFA_STATUS";
export const GET_LOCKED_USERS = "GET_LOCKED_USERS";
export const UPDATE_USER_UNLOCK_STATUS = "UPDATE_USER_UNLOCK_STATUS";
export const getListUsers = () => (dispatch) => {
  dispatch({
    type: GET_LIST_USERS,
    payload: axios
      .get("account?pending=0 ")
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => Promise.reject(error)),
  });
};

export const getPendingUser = () => (dispatch) => {
  return dispatch({
    type: GET_PENDING_USERS,
    payload: axios
      .get("account?pending=1")
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => Promise.reject(error)),
  });
}

export const getProviderUsers = (selectedProvider) => (dispatch) => {
  return dispatch({
    type: GET_PROVIDER_USERS,
    payload: axios
      .get(`account/providerUsers?providerId=${selectedProvider}`)
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => Promise.reject(error)),
  });
}

export const userRegister = (user) => (dispatch) => {
  return dispatch({
    type: USER_REGISTER,
    payload: axios
      .post("account/register", user)
      .then((response) => ({
        data: response.data,
      }))
      .catch((error) => Promise.reject(error)),
  });
};

export const userEdit = (user) => (dispatch) => {
  return dispatch({
    type: USER_EDIT,
    payload: axios
      .put("account/edit", user)
      .then((response) => ({
        data: response.data,
      }))
      .catch((error) => Promise.reject(error)),
  });
};

export const userDelete = (user) => (dispatch) => {
  return dispatch({
    type: USER_DELETE,
    payload: axios
      .delete("account", {
        headers: {
          "Content-Type": "application/json",
        },
        data: user,
      })
      .then((response) => ({
        data: response.data,
        user,
      }))
      .catch((error) => Promise.reject(error)),
  });
};

export const userReject = (user) => (dispatch) => {
  return dispatch({
    type: USER_REJECT,
    payload: axios
      .post(`account/reject`, user)
      .then((response) => ({
        data: response.data,
      }))
      .catch((error) => Promise.reject(error)),
  });
};

export const addProviderInUser = (providerId, userId) => (dispatch) => {
  return dispatch({
    type: ADD_PROVIDER_IN_USER,
    payload: axios
      .put(`provider/${providerId}/users/add/${userId}`)
      .then((response) => response)
      .catch((error) => Promise.reject(error)),
  });
};

export const deleteProviderInUser = (providerId, userId) => (dispatch) => {
  return dispatch({
    type: DELETE_PROVIDER_IN_USER,
    payload: axios
      .put(`provider/${providerId}/users/delete/${userId}`)
      .then((response) => ({
        data: response.data,
        providerId,
        userId,
      }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getUserRoles = () => (dispatch) => {
  return dispatch({
    type: GET_USER_ROLES,
    payload: axios
      .get("account/roles")
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => Promise.reject(error)),
  });
};



export const createPendingUser = (user) => (dispatch) => {
  return dispatch({
    type: CREATE_PENDING_USER,
    payload: axios
      .post("account/createPendingUser", user)
      .then((response) => ({
        data: response.data,
      }))
      .catch((error) => Promise.reject(error)),
  })
}


export const registerPendingUser = (user) => (dispatch) => {
  return dispatch({
    type: REGISTER_PENDING_USER,
    payload: axios
      .post(`account/registerPendingUser`, user)
      .then((response) => ({
        data: response.data,
      }))
      .catch((error) => Promise.reject(error)),
  })
}

export const toggleMFA = (userId, enableMFA) => (dispatch) => {
  return dispatch({
    type: TOGGLE_MFA,
    payload: axios
      .put(`account/toggleMFA`, { userId, enableMFA })
      .then((response) => ({
        data: response.data,
      }))
      .catch((error) => Promise.reject(error)),
  });
};

export const unlockUser = (userId) => (dispatch) => {
  return dispatch({
    type: UNLOCK_USER,
    payload: axios
      .put(`account/unlockUser/${userId}`)
      .then((response) => ({
        data: response.data,
      }))
      .catch((error) => Promise.reject(error)),
  });
};

export const updateMfaUserStatus = (userId, mfaEnabled) => (dispatch) => {
  return dispatch({
    type: UPDATE_USER_MFA_STATUS,
    payload: {
      userId,
      mfaEnabled,
    },
  });
};

export const updateUnlockUserStatus = (userId) => (dispatch) => {
  return dispatch({
    type: UPDATE_USER_UNLOCK_STATUS,
    payload: {
      userId,
    },
  });
}

export const getLockedUsers = () => (dispatch) => {
  dispatch({
    type: GET_LOCKED_USERS,
    payload: axios.get("account/lockedUsers").then((response) => ({
      data: response.data,
    })),
  });
};
